import { useEffect } from 'react';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

import Head from 'next/head';
import styles from 'styles/pages/terms-privacy.module.scss';
import PrivacyLocale from 'locale/en/privacy.json';
import MiscLocale from 'locale/en/misc.json';
import PrivacySideNav from 'components/privacy/side-nav';
import { pageReplaced } from 'lib/utils/page-replaced';
import { getContentSection } from 'lib/contentful/get-content-section';
import { getContentField } from 'lib/contentful/get-content-field';
import { createMarkup } from 'lib/utils/create-markup';
import { getContentfulDataDirect } from 'lib/contentful/get-contentful-data-direct';

const PageData = {
  page_type: 'default',
  page_class: 'page-privacy',
  page_name: PrivacyLocale.page_name,
  page_title: PrivacyLocale.page_title,
  page_description: PrivacyLocale.page_desc,
};
const PageHead = () => (
  <Head>
    <title>{`${MiscLocale.brand} • ${PageData.page_title}`}</title>
    <meta name='description' content={PageData.page_description} />
  </Head>
);

const PagePrivacy = ({ page }) => {
  useEffect(() => {
    pageReplaced(PageData);
  });

  const section = getContentSection({
    data: page,
    include: 'Privacy Policy - Main Section',
  })?.shift();

  const content = getContentField({
    data: section,
    title: 'Privacy Policy - Main Paragraph',
  });

  return (
    <>
      <PageHead />
      <div className={styles.container}>
        <div className={styles.aside}>
          <PrivacySideNav pageUrl='/privacy-policy' />
        </div>
        <div className={styles['sections-list']}>
          <section
            dangerouslySetInnerHTML={createMarkup(
              documentToHtmlString(content).replace(/\n/g, `<br/>`),
            )}
          />
        </div>
      </div>
    </>
  );
};

export async function getStaticProps() {
  const privacyQuery = {
    content_type: 'page',
    'fields.slug': 'privacy-policy',
    include: 10,
  };

  const privacyPayload = await getContentfulDataDirect(privacyQuery);

  const props = {
    page: privacyPayload.items[0].fields,
  };

  return {
    props,
    revalidate: 60 * 60, // One hour in seconds
  };
}

export default PagePrivacy;
